import { render, staticRenderFns } from "./StatisticAdditionalDiscount.vue?vue&type=template&id=468e60db&"
import script from "./StatisticAdditionalDiscount.vue?vue&type=script&lang=ts&"
export * from "./StatisticAdditionalDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports